import { StyleSheet, StatusBar } from 'react-native';
import theme from '../../global/styles/theme';

export const styles = StyleSheet.create({
  container: {
    flex: 1,
    marginTop: StatusBar.currentHeight || 0,
    backgroundColor: theme.colors.white,
  },
  textContainer: {
    color: theme.colors.grey6,
    fontFamily: theme.fonts.title700,
    marginTop: 16,
    fontSize: 12,
  },
  subContainer: {
    marginLeft: 16,
  },
  terceiroContainer: {
    marginLeft: 16,
  },
  segundoTexto: {
    color: theme.colors.grey5,
    fontSize: 12,
    fontFamily: theme.fonts.text400,
    marginTop: 8,
  },
  containerInput: {
    marginLeft: 16,
    marginTop: 16,
  },
  emailText: {
    color: theme.colors.grey6,
    fontFamily: theme.fonts.text400,
    fontWeight: 'bold',
  },
  emailContainer: {
    marginTop: 16,
  },
  textInput: {
    marginTop: 8,
    width: '100%',
    marginRight: 16,
    height: 46,
    borderRadius: 8,
    padding: 8,
    backgroundColor: '#fff',
    borderColor: theme.colors.grey2,
    borderWidth: 1,
  },
  buttonContainer: {
    marginTop: 16,
    marginRight: 16,
  },
  AlterarSenha: {
    marginTop: 16,
    flexDirection: 'row',
  },
  checkbox: {
    marginLeft: 8,
  },
});
